import getEnv from '@/utils/env';

const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';
const QUERY_SERVICE_V2 = getEnv('VUE_APP_QUERY_V2_HOST');

export const HOST_VERSIONS = Object.freeze({
  queryService: 'queryService',
  queryServiceV2: 'queryServiceV2',
});

export const HOSTS = Object.freeze({
  queryService: OAP_HOST,
  queryServiceV2: QUERY_SERVICE_V2,
});
